var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoad)?_c('div',{staticClass:"d-flex flex-wrap"},_vm._l((8),function(n){return _c('div',{key:n,staticClass:"psychologist_wrapper my-skeleton-wrapper"},[_c('v-skeleton-loader',_vm._b({key:n.id,attrs:{"width":"370","height":"490","type":"card-avatar, article, actions"}},'v-skeleton-loader',_vm.attrs,false))],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }